var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourthPClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 1120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      .fourthP0C.fill,\n      .fourthP1C.fill,\n      .fourthP2C.fill,\n      .fourthP3C.fill,\n      .fourthP4C.fill,\n      .fourthP5C.fill{\n        fill: lightgrey;\n        transition: fill 0.5s ease-in-out;\n      }\n      \n      rect{\n        fill: #fff;\n        transition: fill 0.5s ease-in-out;\n      }\n\n      .fourthP0C.show {\n        fill: #fff;\n        transition: fill 0.5s ease-in-out;\n      }\n\n      .fourthP1C.show {\n        fill: #730202;\n        transition: fill 0.5s ease-in-out;\n      }\n\n      .fourthP2C.show {\n        fill: #fedf12;\n        transition: fill 0.5s ease-in-out;\n      }\n\n      .fourthP3C.show {\n        fill: #358e26;\n        transition: fill 0.5s ease-in-out;\n      }\n\n      .fourthP4C.show {\n        fill: #bf0404;\n        transition: fill 0.5s ease-in-out;\n      }\n\n      .fourthP5C.show {\n        fill: #f20519;\n        transition: fill 0.5s ease-in-out;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 7.46,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(-10.54 25.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 32.91,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-21.09 50.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 7.46,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-46.54 40.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(4.37 61.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 58.36,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-31.63 76.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 32.91,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-57.09 65.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 7.46,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-82.54 55.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 83.82,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-6.18 86.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(19.28 97.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 83.82,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-42.17 101.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-67.63 91.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-93.08 80.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-16.72 112.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(8.73 122.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(34.19 133.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-118.54 70.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 109.27,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-52.72 127.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-78.17 116.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 58.36,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-103.63 106.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 134.73,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-27.26 137.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-1.81 148.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 185.64,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(23.65 158.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(49.1 169.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-154.54 85.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-129.08 95.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 134.73,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-63.26 152.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 109.27,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-88.72 142.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-114.17 131.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 160.18,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-37.81 163.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-12.35 173.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(13.1 184.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 236.55,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(38.56 194.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 262,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(64.01 205.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 7.46,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-190.54 100.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-165.08 110.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 58.36,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-139.63 121.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 160.18,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-73.81 178.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 134.73,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-99.26 167.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-124.71 157.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 185.64,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-48.35 188.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 211.09,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-22.9 199.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 236.55,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(2.56 209.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 262,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(28.01 220.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 287.46,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(53.47 230.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(78.92 241.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-226.53 114.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-201.08 125.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 58.36,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-175.62 136.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 83.82,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-150.17 146.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 185.64,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-84.35 203.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 160.18,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-109.8 193.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 134.73,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-135.26 182.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 211.09,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-58.89 214.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 236.55,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-33.44 224.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 262,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-7.99 235.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 287.46,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(17.47 245.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(42.92 256.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 338.37,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(68.38 266.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(93.83 277.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-237.08 140.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-262.53 129.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 58.36,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-211.62 150.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 83.82,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-186.17 161.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 109.27,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-160.71 172.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 211.09,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-94.89 229.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-120.35 218.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 160.18,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-145.8 208) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 236.55,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-69.44 239.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 262,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-43.98 250.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 287.46,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-18.53 260.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 312.91,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(6.93 271.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(32.38 281.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(57.83 292.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(83.29 302.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 414.73,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(108.74 313.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 58.36,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-247.62 165.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-273.08 155.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 7.46,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-298.53 144.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-222.17 176.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-196.71 186.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 134.73,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-171.26 197.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 236.55,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-105.44 254.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 211.09,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-130.89 244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-156.35 233.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 262,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-79.98 265.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 287.46,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-54.53 275.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 312.91,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-29.07 286.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 338.37,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-3.62 296.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 363.82,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(21.84 307.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 389.28,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(47.29 317.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 414.73,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(72.75 328.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 440.18,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(98.2 338.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(123.66 349.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-258.16 191.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-283.62 180.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 32.91,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-309.07 170.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 7.46,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-334.53 159.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 109.27,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-232.71 201.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 134.73,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-207.26 212.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 160.18,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-181.8 222.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 516.55,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-221.42 534.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 491.09,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-210.87 509.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-236.33 498.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 516.55,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-185.42 519.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 465.64,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-200.33 483.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 440.18,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-225.78 473.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 414.73,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-251.24 462.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 491.09,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-174.87 494.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 516.55,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-149.42 504.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 440.18,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-189.79 458.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 414.73,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-215.24 447.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-240.7 437.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-164.33 468.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-138.88 479.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-113.42 489.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-266.15 426.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 414.73,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-179.24 432.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 389.28,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-204.7 422.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-230.15 411.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-153.79 443.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 465.64,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-128.33 453.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-102.88 464.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-77.42 474.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-281.06 390.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 338.37,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-255.61 401.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 389.28,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-168.7 407.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 363.82,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-194.15 396.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-219.61 386.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 414.73,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-143.24 417.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-117.79 428.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 465.64,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-92.33 438.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-66.88 449.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 516.55,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-41.43 459.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 262,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-295.97 354.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 287.46,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-270.52 365.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-245.06 375.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 363.82,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-158.15 381.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 338.37,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-183.61 371.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 312.91,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-209.06 360.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 389.28,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-132.7 392.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 414.73,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-107.25 402.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 440.18,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-81.79 413.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 465.64,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-56.34 423.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-30.88 434.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-5.43 445.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-310.88 318.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 236.55,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-285.43 329.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 262,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-259.97 339.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 287.46,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-234.52 350.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 338.37,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-147.61 356.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 312.91,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-173.07 345.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 287.46,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-198.52 335.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 363.82,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-122.16 366.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 389.28,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-96.7 377.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 414.73,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-71.25 388) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 440.18,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-45.79 398.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 465.64,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-20.34 409.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(5.12 419.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(30.57 430.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 185.64,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-300.34 293.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-325.79 282.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-274.88 303.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 236.55,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-249.43 314.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 262,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-223.98 324.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 312.91,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-137.07 330.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 287.46,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-162.52 320.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 262,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-187.98 309.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-111.61 341.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 363.82,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-86.16 352) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 389.28,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-60.7 362.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 414.73,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-35.25 373.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-9.79 383.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 465.64,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(15.66 394.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(41.11 404.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 516.55,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(66.57 415.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-289.8 267.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-315.25 257.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-340.7 246.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-264.34 278.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 211.09,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-238.89 288.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 236.55,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-213.43 299.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 287.46,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-126.52 305.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 262,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-151.98 294.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 236.55,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-177.43 284.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 312.91,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-101.07 316) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-75.61 326.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 363.82,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-50.16 337.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 389.28,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-24.71 347.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 414.73,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(.75 358.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(26.2 368.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(51.66 379.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 491.09,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(77.11 389.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 516.55,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(102.57 400.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 134.73,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-279.25 242.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-304.71 231.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 83.82,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-330.16 221.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-355.62 210.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 160.18,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-253.8 252.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 185.64,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-228.34 263.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 211.09,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-202.89 273.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 262,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-115.98 280) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 236.55,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-141.43 269.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 211.09,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-166.89 258.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 287.46,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-90.53 290.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 312.91,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-65.07 301.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 338.37,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-39.62 311.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 363.82,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-14.16 322.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 389.28,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(11.29 332.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 414.73,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(36.75 343.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 440.18,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(62.2 353.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 465.64,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(87.66 364.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 491.09,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(113.11 374.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 516.55,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(138.57 385.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 109.27,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-268.71 216.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 83.82,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-294.16 206.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 58.36,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-319.62 195.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 32.91,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-345.07 185.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 7.46,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-370.53 174.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 134.73,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-243.25 227.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 160.18,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-217.8 237.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 185.64,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-192.34 248.37) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 567.45,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(153.48 421.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 592.91,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(142.93 446.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 567.45,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(117.48 436.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 618.36,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(168.39 457.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(132.39 472.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 592.91,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(106.93 461.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 567.45,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(81.48 451.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 643.82,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(157.84 482.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 669.27,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(183.3 493.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 643.82,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(121.85 497.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 618.36,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(96.39 487.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(70.94 476.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 669.27,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(147.3 508.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(172.75 518.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(198.21 529.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(45.48 466.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 669.27,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(111.3 523.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 643.82,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(85.85 512.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(60.39 502.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(136.76 533.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 720.18,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(162.21 544.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 745.64,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(187.67 554.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(213.12 565.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(9.48 481.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 592.91,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(34.94 491.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(100.76 548.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 669.27,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(75.3 538.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(49.85 527.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(126.21 559.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(151.67 569.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 771.09,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(177.12 580.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 796.55,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(202.58 590.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 822,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(228.03 601.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-26.52 495.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 592.91,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-1.06 506.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 618.36,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(24.39 517.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(90.21 574.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(64.76 563.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 669.27,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(39.3 553.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 745.64,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(115.67 584.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(141.12 595.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 796.55,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(166.58 605.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 822,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(192.03 616.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 847.45,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(217.49 626.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(242.94 637.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-62.51 510.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 592.91,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-37.06 521.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-11.6 531.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(13.85 542.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 745.64,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(79.67 599.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 720.18,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(54.22 589.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 694.73,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(28.76 578.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 771.09,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(105.13 610.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 796.55,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(130.58 620.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 822,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(156.03 631.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 847.45,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(181.49 641.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 872.91,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(206.94 652.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 898.36,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(232.4 662.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(257.85 673.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 592.91,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-73.06 536.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-98.51 525.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 618.36,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-47.6 546.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-22.15 557.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 669.27,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(3.31 567.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 771.09,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(69.13 625.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(43.67 614.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 720.18,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(18.22 603.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 796.55,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(94.58 635.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 822,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(120.04 646.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 847.45,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(145.49 656.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(170.95 667.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(196.4 677.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 923.82,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(221.85 688.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(247.31 698.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 974.73,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(272.76 709.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-83.6 561.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-109.06 551.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 567.45,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-134.51 540.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-58.15 572.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 669.27,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-32.69 582.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 694.73,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-7.24 593.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 796.55,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(58.58 650.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 771.09,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(33.13 639.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(7.67 629.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 822,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(84.04 661.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 847.45,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(109.49 671.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 872.91,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(134.95 682.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 898.36,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(160.4 692.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(185.86 703.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(211.31 713.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 974.73,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(236.77 724.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1000.18,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(262.22 734.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1025.64,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(287.67 745.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 643.82,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-94.14 587.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 618.36,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-119.6 576.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 592.91,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-145.05 566.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 567.45,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-170.51 555.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 669.27,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-68.69 597.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-43.24 608.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 720.18,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-17.78 618.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1076.55,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-57.4 930.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1051.09,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-46.85 905.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1025.64,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-72.31 894.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1076.55,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-21.4 915.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-36.31 879.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1000.18,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-61.76 869.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 974.73,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-87.22 858.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1051.09,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-10.86 890.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1076.55,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(14.6 900.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1000.18,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-25.77 854.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 974.73,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-51.22 843.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-76.68 833.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1025.64,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-.31 864.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(25.14 875.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(50.6 885.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-102.13 822.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 974.73,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-15.22 828.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-40.68 818.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 923.82,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-66.13 807.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1000.18,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(10.23 839.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(35.69 849.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1051.09,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(61.14 860.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(86.6 870.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-117.04 786.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 898.36,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-91.59 797.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-4.68 803.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-30.13 792.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-55.59 782.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 974.73,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(20.78 813.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(46.23 824.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1025.64,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(71.68 834.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1051.09,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(97.14 845.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(122.59 855.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 822,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-131.95 750.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 847.45,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-106.5 761.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 872.91,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-81.04 771.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(5.86 777.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 898.36,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-19.59 767.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-45.04 756.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(31.32 788.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(56.77 798.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(82.23 809.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(107.68 819.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1051.09,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(133.14 830.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(158.59 841.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-146.86 714.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 796.55,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-121.41 725.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 822,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-95.95 735.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 847.45,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-70.5 746.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 898.36,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(16.41 752.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 872.91,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-9.05 741.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 847.45,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-34.5 731.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 923.82,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(41.86 762.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 949.27,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(67.32 773.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 974.73,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(92.77 783.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(118.23 794.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1025.64,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(143.68 805.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1051.09,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(169.14 815.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(194.59 826.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 745.64,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-136.32 689.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-161.77 678.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 771.09,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-110.86 699.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 796.55,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-85.41 710.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 822,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-59.96 720.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 872.91,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(26.95 726.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 847.45,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(1.5 716.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 822,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-23.96 705.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(52.41 737.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 923.82,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(77.86 747.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 949.27,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(103.32 758.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(128.77 769.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(154.23 779.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(179.68 790.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(205.13 800.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1076.55,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(230.59 811.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 720.18,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-125.78 663.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-151.23 653.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 669.27,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-176.69 642.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-100.32 674.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-74.87 684.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 796.55,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-49.41 695.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 847.45,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(37.5 701.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 822,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(12.04 690.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 796.55,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-13.41 680.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 872.91,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(62.95 711.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(88.4 722.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 923.82,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(113.86 733.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(139.31 743.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 974.73,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(164.77 754.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1000.18,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(190.22 764.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1025.64,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(215.68 775.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1051.09,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(241.13 785.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1076.55,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(266.59 796.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-115.23 638.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 669.27,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-140.69 627.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 643.82,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-166.14 617.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 618.36,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-191.6 606.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-89.78 648.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 745.64,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-64.32 659.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 771.09,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-38.87 669.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 822,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(48.04 675.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 796.55,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(22.58 665.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 771.09,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-2.87 654.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 847.45,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(73.49 686.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 872.91,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(98.95 697.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 898.36,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(124.4 707.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(149.86 718.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(175.31 728.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 974.73,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(200.77 739.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1000.18,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(226.22 749.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(251.68 760.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 1051.09,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(277.13 770.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1076.55,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(302.59 781.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 669.27,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-104.69 612.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 643.82,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-130.14 602.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-155.6 591.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 592.91,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-181.05 581.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 567.45,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-206.51 570.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-79.23 623.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-53.78 633.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 745.64,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-28.32 644.35) rotate(-45)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1076.55,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(1454.53 1773.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1051.09,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(1393.07 1798.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1076.55,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(1418.53 1860.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(1367.62 1737.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1025.64,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(1331.62 1824.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1051.09,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(1357.08 1885.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1076.55,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(1382.53 1947.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1000.18,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(1306.17 1762.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(1280.71 1701.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1000.18,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(1270.17 1849.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(1295.62 1911.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(1321.08 1972.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(1244.71 1788.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(1219.26 1726.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(1193.8 1665.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(1346.53 2034.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 974.73,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(1208.72 1875.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(1234.17 1936.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1025.64,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(1259.62 1998.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 949.27,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(1183.26 1813.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(1157.81 1752.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 898.36,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(1132.35 1690.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(1106.9 1629.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(1310.53 2121.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(1285.08 2059.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 949.27,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(1147.26 1900.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 974.73,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(1172.72 1962.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(1198.17 2023.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 923.82,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(1121.81 1839.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(1096.35 1777.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(1070.9 1716.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 847.45,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(1045.44 1654.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 822,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(1019.99 1593.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 1076.55,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(1274.54 2207.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(1249.08 2146.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1025.64,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(1223.63 2085.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 923.82,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(1085.81 1926.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 949.27,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(1111.26 1987.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(1136.72 2049.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 898.36,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(1060.35 1864.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 872.91,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(1034.9 1803.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 847.45,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(1009.45 1741.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 822,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(983.99 1680.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 796.55,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(958.54 1618.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(933.08 1557.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(1238.54 2294.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(1213.08 2233.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 1025.64,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(1187.63 2171.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1000.18,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(1162.17 2110.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 898.36,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(1024.36 1951.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 923.82,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(1049.81 2013.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 949.27,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(1075.27 2074.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 872.91,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(998.9 1890.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 847.45,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(973.45 1828.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 822,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(947.99 1767.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 796.55,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(922.54 1705.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(897.08 1644.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 745.64,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(871.63 1582.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(846.17 1521.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(1177.08 2320.29) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1076.55,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(1202.54 2381.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1025.64,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(1151.63 2258.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 1000.18,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(1126.17 2197.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 974.73,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(1100.72 2135.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 872.91,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(962.9 1977.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(988.36 2038.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 923.82,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(1013.81 2099.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 847.45,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(937.45 1915.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 822,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(911.99 1854.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 796.55,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(886.54 1792.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 771.09,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(861.08 1731.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(835.63 1669.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(810.18 1608.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(784.72 1546.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 669.27,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(759.27 1485.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1025.64,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(1115.63 2345.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 1051.09,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(1141.09 2407.2) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1076.55,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(1166.54 2468.65) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(1090.18 2284.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(1064.72 2222.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 949.27,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(1039.27 2161.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 847.45,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(901.45 2002.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 872.91,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(926.9 2063.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(952.36 2125.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 822,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(876 1941.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 796.55,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(850.54 1879.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 771.09,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(825.09 1818.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 745.64,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(799.63 1756.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 720.18,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(774.18 1695.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 694.73,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(748.72 1633.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 669.27,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(723.27 1572.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 643.82,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(697.81 1510.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(672.36 1449.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1000.18,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(1054.18 2371.2) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(1079.63 2432.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1051.09,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(1105.09 2494.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1076.55,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(1130.54 2555.56) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 974.73,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(1028.72 2309.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 949.27,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(1003.27 2248.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 923.82,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(977.81 2186.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 567.45,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(225.47 2282.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 592.91,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(286.92 2257.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(312.38 2318.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 567.45,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(261.47 2195.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 618.36,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(348.37 2231.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 643.82,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(373.83 2293.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 669.27,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(399.28 2354.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 592.91,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(322.92 2170.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 567.45,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(297.46 2108.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 643.82,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(409.83 2206.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 669.27,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(435.28 2267.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 694.73,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(460.74 2329.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(384.37 2144.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(358.92 2083.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(333.46 2021.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(486.19 2390.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 669.27,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(471.28 2180.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 694.73,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(496.73 2242.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 720.18,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(522.19 2303.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(445.83 2119.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 618.36,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(420.37 2057.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(394.92 1996.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(369.46 1934.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(573.1 2426.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 745.64,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(547.64 2365.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 694.73,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(532.73 2155.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 720.18,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(558.19 2216.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(583.64 2278.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 669.27,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(507.28 2093.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(481.82 2032.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 618.36,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(456.37 1970.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(430.91 1909.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 567.45,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(405.46 1847.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 822,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(660.01 2462.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 796.55,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(634.55 2401.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 771.09,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(609.1 2339.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 720.18,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(594.19 2129.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 745.64,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(619.64 2191.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 771.09,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(645.1 2252.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 694.73,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(568.73 2068.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 669.27,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(543.28 2006.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 643.82,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(517.82 1945.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 618.36,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(492.37 1883.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(466.91 1822.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(441.46 1761.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(746.91 2498.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 847.45,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(721.46 2437.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 822,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(696 2375.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 796.55,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(670.55 2314.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 745.64,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(655.64 2104.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 771.09,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(681.09 2165.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 796.55,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(706.55 2227.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 720.18,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(630.18 2042.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 694.73,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(604.73 1981.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 669.27,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(579.28 1919.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 643.82,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(553.82 1858.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 618.36,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(528.37 1797.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(502.91 1735.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 567.45,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(477.46 1674.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 898.36,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(808.37 2473.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(833.82 2534.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 872.91,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(782.91 2411.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 847.45,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(757.46 2350.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 822,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(732 2288.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 771.09,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(717.09 2078.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 796.55,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(742.55 2140.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 822,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(768 2201.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(691.64 2017.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 720.18,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(666.18 1955.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 694.73,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(640.73 1894.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 669.27,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(615.27 1833.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(589.82 1771.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 618.36,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(564.36 1710.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 592.91,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(538.91 1648.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 567.45,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(513.45 1587.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 923.82,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(869.82 2447.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 949.27,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(895.27 2509.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(920.73 2570.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 898.36,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(844.37 2386.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 872.91,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(818.91 2324.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 847.45,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(793.46 2263.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 796.55,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(778.54 2053.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 822,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(804 2114.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 847.45,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(829.45 2176.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 771.09,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(753.09 1991.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 745.64,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(727.64 1930.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 720.18,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(702.18 1869.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 694.73,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(676.73 1807.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 669.27,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(651.27 1746.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 643.82,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(625.82 1684.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 618.36,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(600.36 1623.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 592.91,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(574.91 1561.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 567.45,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(549.45 1500.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 949.27,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(931.27 2422.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 974.73,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(956.73 2483.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1000.18,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(982.18 2545.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1025.64,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(1007.64 2606.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 923.82,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(905.82 2360.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 898.36,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(880.36 2299.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 872.91,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(854.91 2237.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 822,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(840 2027.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 847.45,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(865.45 2089.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 872.91,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(890.91 2150.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 796.55,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(814.54 1966.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 771.09,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(789.09 1905.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 745.64,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(763.63 1843.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 720.18,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(738.18 1782.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 694.73,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(712.72 1720.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 669.27,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(687.27 1659.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 643.82,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(661.81 1597.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 618.36,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(636.36 1536.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 592.91,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(610.91 1474.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 567.45,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(585.45 1413.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 974.73,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(992.73 2396.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1000.18,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(1018.18 2458.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1025.64,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(1043.63 2519.56) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 1051.09,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(1069.09 2581.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 1076.55,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(1094.54 2642.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 949.27,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(967.27 2335.2) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 923.82,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(941.82 2273.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 898.36,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(916.36 2212.3) rotate(-135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 516.55,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(498.55 1377.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 491.09,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(437.1 1402.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 516.55,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(462.55 1464.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 465.64,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(411.64 1341.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(375.64 1428.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 491.09,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(401.1 1489.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 516.55,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(426.55 1551.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 440.18,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(350.19 1366.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 414.73,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(324.74 1305.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 440.18,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(314.19 1453.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 465.64,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(339.65 1515.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(365.1 1576.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 414.73,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(288.74 1392.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(263.28 1330.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(237.83 1269.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(390.56 1638.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 414.73,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(252.74 1479.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 440.18,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(278.19 1540.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(303.65 1602.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(227.28 1417.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 363.82,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(201.83 1356.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 338.37,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(176.38 1294.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(150.92 1233.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(354.56 1725.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 491.09,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(329.1 1663.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(191.29 1504.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 414.73,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(216.74 1566.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(242.2 1627.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(165.83 1443.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(140.38 1381.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 312.91,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(114.92 1320.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 287.46,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(89.47 1258.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 262,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(64.01 1197.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(318.56 1811.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 491.09,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(293.1 1750.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 465.64,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(267.65 1689.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(129.83 1530.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(155.29 1591.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 414.73,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(180.74 1653.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 338.37,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(104.38 1468.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(78.92 1407.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 287.46,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(53.47 1345.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 262,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(28.01 1284.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 236.55,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(2.56 1222.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-22.89 1161.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(282.56 1898.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 491.09,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(257.11 1837.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(231.65 1775.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(206.2 1714.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 338.37,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(68.38 1555.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 363.82,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(93.83 1617.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 389.28,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(119.29 1678.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 312.91,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(42.93 1494.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 287.46,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(17.47 1432.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 262,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-7.98 1371.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 236.55,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-33.44 1309.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 211.09,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-58.89 1248.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 185.64,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-84.35 1186.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-109.8 1125.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 491.09,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(221.11 1924.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 516.55,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(246.56 1985.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 465.64,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(195.65 1862.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(170.2 1801.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 414.73,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(144.74 1739.96) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 312.91,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(6.93 1581.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(32.38 1642.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 363.82,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(57.84 1703.96) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 287.46,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-18.53 1519.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 262,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-43.98 1458.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 236.55,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-69.44 1396.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-94.89 1335.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-120.35 1273.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 160.18,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-145.8 1212.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-171.26 1150.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 109.27,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-196.71 1089.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(159.65 1949.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 491.09,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(185.11 2011.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 516.55,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(210.56 2072.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 440.18,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(134.2 1888.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 414.73,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(108.75 1826.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 389.28,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(83.29 1765.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 287.46,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-54.53 1606.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 312.91,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-29.07 1667.96) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-3.62 1729.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 262,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-79.98 1545.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 236.55,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-105.44 1483.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 211.09,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-130.89 1422.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 185.64,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-156.34 1360.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-181.8 1299.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-207.25 1237.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 109.27,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-232.71 1176.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 83.82,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-258.16 1114.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 58.36,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-283.62 1053.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 440.18,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(98.2 1975.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 465.64,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(123.66 2036.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 491.09,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(149.11 2098.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 516.55,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(174.57 2159.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 414.73,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(72.75 1913.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(47.29 1852.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 363.82,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(21.84 1790.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 7.46,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-730.51 1886.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 32.91,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-669.05 1861.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 58.36,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-643.6 1922.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 7.46,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-694.51 1799.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-607.6 1835.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 83.82,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-582.15 1897.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 109.27,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-556.69 1958.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 32.91,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-633.06 1774.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 7.46,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-658.51 1712.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 83.82,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-546.15 1810.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 109.27,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-520.69 1871.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-495.24 1933.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 58.36,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-571.6 1748.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-597.06 1687.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-622.51 1625.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-469.79 1994.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 109.27,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-484.7 1784.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-459.24 1846.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 160.18,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-433.79 1907.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 83.82,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-510.15 1723.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-535.61 1661.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 32.91,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-561.06 1600.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-586.51 1538.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-382.88 2030.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 185.64,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-408.33 1969.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-423.24 1759.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-397.79 1820.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-372.33 1882.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 109.27,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-448.7 1697.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-474.15 1636.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 58.36,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-499.61 1574.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 32.91,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-525.06 1513.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-550.52 1451.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 262,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-295.97 2066.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 236.55,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-321.42 2005.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 211.09,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-346.88 1943.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-361.79 1733.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 185.64,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-336.34 1795.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 211.09,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-310.88 1856.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-387.24 1672.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-412.7 1610.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-438.15 1549.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-463.61 1487.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 32.91,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-489.06 1426.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-514.52 1365.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-209.06 2102.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 287.46,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-234.52 2041.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 262,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-259.97 1979.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 236.55,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-285.43 1918.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 185.64,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-300.34 1708.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 211.09,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-274.88 1769.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 236.55,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-249.43 1831.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 160.18,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-325.79 1646.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 134.73,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-351.25 1585.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 109.27,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-376.7 1523.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-402.16 1462.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 58.36,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-427.61 1401.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 32.91,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-453.07 1339.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 7.46,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-478.52 1278.16) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 338.37,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-147.61 2077.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-122.15 2138.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP3C",
    x: 312.91,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-173.06 2015.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 287.46,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-198.52 1954.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 262,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-223.97 1892.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 211.09,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-238.88 1682.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 236.55,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-213.43 1744.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 262,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-187.98 1805.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-264.34 1621.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 160.18,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-289.79 1559.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 134.73,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-315.25 1498.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 109.27,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-340.7 1437.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 83.82,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-366.16 1375.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-391.61 1314.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 32.91,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-417.07 1252.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 7.46,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-442.52 1191.25) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 363.82,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-86.16 2051.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-60.7 2113.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 414.73,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-35.25 2174.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 338.37,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-111.61 1990.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 312.91,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-137.07 1928.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 287.46,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-162.52 1867.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 236.55,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-177.43 1657.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 262,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-151.98 1718.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 287.46,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-126.52 1780.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 211.09,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-202.89 1595.96) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 185.64,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-228.34 1534.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 160.18,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-253.8 1473.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-279.25 1411.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 109.27,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-304.7 1350.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 83.82,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-330.16 1288.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 58.36,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-355.61 1227.25) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 32.91,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-381.07 1165.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 7.46,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-406.52 1104.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-24.7 2026.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 414.73,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(.75 2087.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 440.18,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(26.21 2149.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 465.64,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(51.66 2210.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-50.16 1964.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 338.37,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-75.61 1903.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 312.91,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-101.07 1841.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 262,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-115.98 1631.96) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 287.46,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-90.52 1693.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 312.91,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-65.07 1754.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP5C",
    x: 236.55,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-141.43 1570.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 211.09,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-166.89 1509.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 185.64,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-192.34 1447.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 160.18,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-217.8 1386.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 134.73,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-243.25 1324.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 109.27,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-268.71 1263.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 83.82,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-294.16 1201.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 58.36,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-319.62 1140.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 32.91,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-345.07 1078.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 7.46,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-370.53 1017.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 414.73,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(36.75 2000.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 440.18,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(62.2 2062.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP1C",
    x: 465.64,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(87.66 2123.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP0C",
    x: 491.09,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(113.11 2185.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 516.55,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(138.57 2246.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 389.28,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(11.29 1939.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP2C",
    x: 363.82,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-14.16 1877.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "fourthP4C",
    x: 338.37,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-39.61 1816.32) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthPClear);
export default __webpack_public_path__ + "static/media/FourthP_Clear.1a92f8794001a5e24bff7b14e64d30ef.svg";
export { ForwardRef as ReactComponent };